/* istanbul ignore file */
import { UpdateForm } from 'framework/form';
import React from 'react';
import useEmployeeFeedbackService from 'domain/people/employee/Timeline/feedback/employeeFeedbackService';
import FeedbackForm from 'domain/people/employee/Timeline/feedback/form/FeedbackForm';
import { UpdateTimelineItemLayout } from 'framework/ui/timeline';

const UpdateFeedbackForm = ({ getDataFunc, onCancel, ...props }: any) => {
  const { getValidationSchema, update } = useEmployeeFeedbackService();

  return (
    <UpdateForm
      getDataFunc={getDataFunc}
      submitFormFunc={update}
      getValidationSchemaFunc={getValidationSchema}
      {...props}
    >
      <UpdateTimelineItemLayout onCancel={onCancel}>
        <FeedbackForm />
      </UpdateTimelineItemLayout>
    </UpdateForm>
  );
};

export default UpdateFeedbackForm;
